import React, { useEffect, useRef } from 'react'
import { FormattedDate } from 'react-intl'
import Slider from 'react-input-slider'
import { useTrustpilotReviews } from 'hooks/trustpilot'
import { RatingStars } from 'components/Reviews/components/RatingStars'
import { ReviewWrapper, ReviewsList, ReviewSummary, NoReviews } from './styled'
import { useProductByPath } from 'lib/modules/catalog'

interface Props {
  type?: string
}

export const TrustpilotReviews = () => {
  const { product } = useProductByPath()
  const { reviewsOverview, reviews } = useTrustpilotReviews(true, product?.sku)
  const productReviews = reviews?.productReviews
  const summary = reviewsOverview
  const { starsAverage, numberOfReviews } = summary ?? {}

  if (numberOfReviews?.total === 0) return null

  return (
    <div>
      <h2>
        Reviews
      </h2>
      {productReviews ? (
        <>
          <ReviewSummary>
            {(numberOfReviews?.total === 0) && (
              <p>Be the first to write a customer review.</p>
            )}
            <RatingStars
              ratingCount={starsAverage}
            />
            <span>{numberOfReviews?.total} Reviews</span>
            <TrustpilotWidget
              type='trustScore'
            />
          </ReviewSummary>
          <ReviewsList>
            {productReviews?.map((review: any, i: number) => {
              const { stars, content, consumer, createdAt, attributeRatings } = review
              const fitRating = attributeRatings?.find((attribute: any) => attribute.attributeId === 'attributes.default.fit')?.rating
              return (
                <ReviewWrapper
                  key={i}
                >
                  <RatingStars
                    ratingCount={stars}
                  />
                  <h3 className='review__title'>{content}</h3>
                  <div className='review__cotent'>
                    <div>
                      <div>{consumer.displayName}</div>
                      <FormattedDate
                        value={createdAt}
                        day='numeric'
                        month='long'
                        year='numeric'
                      />
                    </div>
                    <div className='review__slider'>
                      <p>Fit Scale: {fitRating} of 5</p>
                      <Slider
                        axis='x'
                        x={fitRating}
                        xmin={1}
                        xmax={5}
                      />
                      <div className='slider__label'>
                        <span>Not true to size</span>
                        <span>Perfect fit</span>
                      </div>
                    </div>
                  </div>

                </ReviewWrapper>
              )
            })}
          </ReviewsList>
          <TrustpilotWidget
            type='button'
          />
        </>
      ) : (
        <NoReviews>
          There are no reviews for this product yet
        </NoReviews>
      )}
    </div>
  )
}

export const TrustpilotWidget: React.FC<Props> = ({ type }) => {
  const ref = useRef(null)
  useEffect(() => {
    if ((window as any).Trustpilot) {
      (window as any).Trustpilot.loadFromElement(ref.current, true)
    }
  }, [])

  const templateId = type === 'button' ? '56278e9abfbbba0bdcd568bc' : '5419b637fa0340045cd0c936'
  const height = type === 'button' ? '52px' : '30px'

  return (
    <div
      ref={ref}
      className='trustpilot-widget'
      data-locale='en-US'
      data-template-id={templateId}
      data-businessunit-id='5f621e2d873ddf00015016bb'
      data-style-height={height}
      data-style-width='100%'
    >
      <a
        href='https://www.trustpilot.com/review/sofiaandgrace.com'
        target='_blank' rel='noopener noreferrer'
      >Trustpilot
      </a>
    </div>
  )
}
